import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

export interface Product {
  _id?: string;
  id?: number;
  name: string;
  category: string;
  categoryId: string;
  price: number;
  originalPrice?: number;
  image: string;
  images?: string[];
  rating: number;
  reviews: number;
  isNew?: boolean;
  isSale?: boolean;
  description: string;
  shortDescription?: string;
  isCustomizable?: boolean;
  customizationOptions?: string[];
  showOnHome?: boolean;
  showOnProducts?: boolean;
  status: 'active' | 'inactive' | 'draft';
}

@Injectable({
  providedIn: 'root'
})
export class ProductStoreService {
  private apiUrl = 'https://aadinathapi.beatsacademy.in';

  constructor(private http: HttpClient) {}

  // Get all products from API
  getAllProducts(): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/products/all/`);
  }

  // Add a new product via API
  addProduct(product: Product, imageFile?: File): Observable<any> {
    const formData = new FormData();
    
    // Add all product fields to FormData
    Object.entries(product).forEach(([key, value]) => {
      if (key === 'image') {
        // Skip the image field - we'll handle it separately
        return;
      }
      
      // Handle boolean values properly
      if (typeof value === 'boolean') {
        formData.append(key, value.toString());
      }
      // If value is an array, stringify it (for customizationOptions, etc.)
      else if (Array.isArray(value)) {
        formData.append(key, JSON.stringify(value));
      } else if (value !== undefined && value !== null) {
        formData.append(key, value.toString());
      }
    });

    // Add the actual image file if provided
    if (imageFile) {
      formData.append('image', imageFile, imageFile.name);
    }

    // Set default values for showOnHome and showOnProducts if not provided
    if (!formData.has('showOnHome')) {
      formData.append('showOnHome', 'true');
    }
    if (!formData.has('showOnProducts')) {
      formData.append('showOnProducts', 'true');
    }

    return this.http.post<any>(`${this.apiUrl}/products/add/`, formData);
  }

  // Get product by ID
  getProductById(id: number): Observable<any> {
    return this.http.get<any>(`${this.apiUrl}/products/details/${id}/`);
  }

  // Update product
  updateProduct(id: number, product: Product): Observable<any> {
    return this.http.put<any>(`${this.apiUrl}/products/update/${id}/`, product);
  }

  // Partial update product
  partialUpdateProduct(id: number, updates: Partial<Product>): Observable<any> {
    return this.http.patch<any>(`${this.apiUrl}/products/partialupdate/${id}/`, updates);
  }

  // Delete product
  deleteProduct(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/products/delete/${id}/`);
  }
}
